class LocalizationSelector extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.dropdowns = this.querySelectorAll('[data-localization-dropdown]');

    this.dropdowns.forEach((dropdown) => {
      const trigger = dropdown.querySelector('[data-localization-trigger]');
      const menu = dropdown.querySelector('[data-localization-menu]');

      trigger.addEventListener('click', (event) => {
        event.stopPropagation();
        const isOpen = !menu.hidden;
        this.closeAll();
        if (!isOpen) this.open(trigger, menu);
      });

      menu.querySelectorAll('[data-localization-option]').forEach((option) => {
        option.addEventListener('click', () => this.select(dropdown, option));
      });
    });

    document.addEventListener('click', () => this.closeAll());
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closeAll();
    });
  }

  open(trigger, menu) {
    menu.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
  }

  closeAll() {
    this.querySelectorAll('[data-localization-menu]').forEach((menu) => {
      menu.hidden = true;
    });
    this.querySelectorAll('[data-localization-trigger]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
    });
  }

  select(dropdown, option) {
    const target = option.dataset.target;
    const value = option.dataset.value;
    const label = option.dataset.label;
    const input = this.querySelector(`[data-localization-input="${target}"]`);
    if (input) input.value = value;

    const trigger = dropdown.querySelector('[data-localization-trigger]');
    const triggerFlag = trigger.querySelector('[data-localization-trigger-flag]');
    const triggerLabel = trigger.querySelector('[data-localization-trigger-label]');
    const optionFlag = option.querySelector('svg');
    if (triggerFlag && optionFlag) triggerFlag.innerHTML = optionFlag.innerHTML;
    if (triggerLabel) triggerLabel.textContent = label;

    if (this.form) this.form.submit();
  }
}

if (!customElements.get('localization-selector')) {
  customElements.define('localization-selector', LocalizationSelector);
}
